import { render } from "./BuscadorView.vue?vue&type=template&id=3aea7bc1&scoped=true"
import script from "./BuscadorView.vue?vue&type=script&lang=js"
export * from "./BuscadorView.vue?vue&type=script&lang=js"

import "./BuscadorView.vue?vue&type=style&index=0&id=3aea7bc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aea7bc1"]])

export default __exports__